import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './login/login.component';
import {MdInputModule, MdButtonModule, MdCardModule} from '@angular/material';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AuthService} from '../user/services/auth/auth.service';
import {CallbackComponent} from '../user/components/callback/callback.component';
import {CanActivateHomeService} from '../layout/services/guards/can-activate-home.service';
import {NotFoundComponent} from './not-found/not-found.component';
import {UtilitiesModule} from '../utilities/utilities.module';
import {LayoutModule} from '../layout/layout.module';


@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    MdInputModule,
    MdButtonModule,
    MdCardModule,
    UtilitiesModule,
    LayoutModule
  ],
  declarations: [
    LoginComponent,
    CallbackComponent,
    NotFoundComponent
  ],
  providers: [
    AuthService,
    CanActivateHomeService
  ],
  exports: [
    LoginComponent,
    NotFoundComponent
  ]
})
export class PublicModule {}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/public/public.module.ts